import { createMedia } from "@tamagui/react-native-media-driver";
const BREAKPOINTS = {
  SM: 375,
  MD: 768,
  LG: 1201,
  XL: 1400
}, media = createMedia({
  smallerThanXL: { maxWidth: BREAKPOINTS.XL - 1 },
  smallerThanLG: { maxWidth: BREAKPOINTS.LG - 1 },
  smallerThanMD: { maxWidth: BREAKPOINTS.MD - 1 },
  smallerThanSM: { maxWidth: BREAKPOINTS.SM - 1 },
  largerThanXS: { minWidth: BREAKPOINTS.SM },
  largerThanSM: { minWidth: BREAKPOINTS.MD },
  largerThanMD: { minWidth: BREAKPOINTS.LG },
  largerThanLG: { minWidth: BREAKPOINTS.XL },
  // use to target devices that do not support hover
  hoverNone: { hover: "none" }
});
export {
  BREAKPOINTS,
  media
};
